import 'reflect-metadata';
import {jsonObject, jsonMember, TypedJSON} from 'typedjson';

import {LoraPacketTxInfo} from '@/model/lora/LoraPacket/LoraPacketTxInfo';
import {LoraPacketType} from '@/model/lora/LoraPacket/LoraPacketType';
import {LoraMessageType} from '@/model/lora/LoraPacket/LoraMessageType';

@jsonObject({
  typeResolver: LoraPacket.TypeResolver,
})
export abstract class LoraPacket {

  public static TypeResolver(loraPacket: any, knownTypes: Map<string, Function>) {

    switch (loraPacket.messageType) {
      case LoraMessageType.JoinRequest:
        return knownTypes.get('LoraPacketUplinkJoinRequest');
      case LoraMessageType.ConfirmedDataUp:
      case LoraMessageType.UnconfirmedDataUp:
        return knownTypes.get('LoraPacketUplinkData');
      case LoraMessageType.JoinAccept:
      case LoraMessageType.ConfirmedDataDown:
      case LoraMessageType.UnconfirmedDataDown:
        return knownTypes.get('LoraPacketDownlink');
      default:
        switch (loraPacket.direction) {
          case LoraPacketType.Uplink:
            return knownTypes.get('LoraPacketUplink');
          case LoraPacketType.Downlink:
            return knownTypes.get('LoraPacketDownlink');
        }
    }
  }

  public static get Serializer(): TypedJSON<LoraPacket> {
    if (!LoraPacket.serializer) {
      LoraPacket.serializer = new TypedJSON(LoraPacket);
    }

    return LoraPacket.serializer;
  }

  private static serializer: TypedJSON<LoraPacket> | undefined;

  @jsonMember({name: 'messageType', constructor: Number})
  public MessageType!: LoraMessageType;

  @jsonMember({name: 'time'})
  public Time!: Date;

  @jsonMember({name: 'timestamp'})
  public Timestamp!: number;

  @jsonMember({name: 'size'})
  public Size!: number;

  @jsonMember({name: 'payload'})
  public Payload!: string;

  @jsonMember({name: 'txInfo'})
  public TxInfo!: LoraPacketTxInfo;

  public abstract get Type(): LoraPacketType;
}
